export const CONSTANTS = {
  ACTIONS: {
    DISABLE: "disable",
    ENABLE: "enable",
    VIEW: "view",
  },
  ACTIVE: "Active",
  ACTIVITY_OFFICE: "a1090b2b-e023-4eeb-8c2f-1da5e64e2bbb",
  ACTIVITY_PROFESSIONAL: "39d74efa-b9e3-45d9-9dbf-2d355432aaf7",
  ADD: "add",
  ADD_FORM: 1,
  ADD_INFO: "add_info",
  ADD_MODAL: "add",
  ADD_ONE: 1,
  ADMIN_USER: 4,
  API: {
    AUTH: "Authorization",
    BEARER: "Bearer ",
    TIMEOUT: 100000,
  },
  ARRAY_DEFAULT_VALUE: 0,
  ASSIGNMENT_STATUS: {
    CURRENT: 2,
  },
  BADGE_STATUS: {
    DANGER: "danger",
    SUCCESS: "success",
  },
  BEHALF: {
    ADMIN: 3,
    OFFICE: 1,
  },
  CANCELLED_BY_ADMIN: 3,
  CANCELLED_BEHALF_OF_OFFICE: 4,
  CATEGORY_UUID: "categoryUuid",
  CHILD_ID: "childAddress",
  MIXED_MODEL: "mixedModelAddress",
  CLOSE_ICON: "x",
  CONFIRM: "confirm",
  CONTRACT_LIST: {
    ACH: "b71e9670-ff0f-4ff7-a540-acca27e62194",
    CREDIT_CARD: "1544eeda-f682-4411-bd9d-8877764aae2f",
  },
  CONTRACTS: {
    ACH: "ACH",
    ACH_ID: "b71e9670-ff0f-4ff7-a540-acca27e62194",
    ACH_PAYMENT_ID: "8945f089-df19-42ba-bf33-80f034b750de",
    DIRECT_DEPOSIT: "0fcd7aae-fc4f-451a-a604-6c0befd9719b",
    CHECK: "61eafe83-d6a6-4d5b-acc5-ddb17ef1ba7b",
    ADDENDUM_ID: "6192237f-8720-415c-973d-72bf1dbe0719",
    AGREEMENT_AND_CONTENT_TO_DRUG_ID: "70a6dd9b-81e4-42cf-96e1-b36f17c1b6e4",
    BACKROUND_FCRA_ID: "b5a0b3ff-50e5-4fc1-92e7-ede7bf0438c9",
    CREDIT_CARD_ID: "1544eeda-f682-4411-bd9d-8877764aae2f",
    EXHIBIT_A1: "5b5b3bce-ded5-41ea-be46-6ffe26c34c6d",
    EXHIBIT_A2: "08917b2c-d0fa-4cd0-a3b3-233980c4a24e",
    EXHIBIT_B: "1bff75fd-b67e-4061-97f0-9b8e456c9e6a",
    EXHIBIT_C: "c4c96dd3-c7d8-4165-a0ae-816d51afa0f4",
    HBV_ID: "cf6cec70-423e-473a-813e-28394b65fd3f",
    MARKETPLACE_AND_HANDBOOK_ID: "80192f95-84ae-49d9-9727-ef936156ef6d",
    MASTER_FULL_SERVICE_AGREEMENT: "48ce0a5c-3d11-45cc-88e8-6ef13974d702",
    MASTER_FULL_SERVICE_AGREEMENT2: "04568c0d-47ca-4c7f-b407-fa34d20765c0",
    NON_SOLICITATION_AGREEMENT_ID: "a4efe5ea-87b0-4d41-91f4-e751686f720b",
    PRIVACY_TRAINING_MODULE_ID: "cf047e38-baaf-4f57-877f-3363c8183a71",
  },
  CONTRACT_TYPE: "contract",
  COMMON_CONSTANTS: {
    CLOSE: false,
    CONTRACT_TYPE_OTHER: "other",
    EMPTY_SPACE: " ",
    EMPTY_VALUE: "",
    ELLIPSIS: "...",
    FIRST_DAY: 1,
    FIXED_VALUE: 2,
    HIDE: false,
    NO: false,
    OPEN: true,
    SHOW: true,
    START_LOADER: true,
    STOP_LOADER: false,
    TIMESHEET_UUID: "timesheetUuid",
    TRUE_STRING_NUMBER: "1",
    USER_ID: "userId",
    YES: true,
    ZERO: 0,
    SALUTATION: { MR: "Mr.", MS: "Ms.", MRS: "Mrs.", DR: "Dr." },
  },
  CONTRACT: 1,
  DATE: {
    FIRST_DAY: 1,
    JULY: 6,
    JUNE: 5,
    LAST_DAY: 30,
    ONE_YEAR: 1,
  },
  DATE_FORMAT: "MM-DD-YYYY",
  DATE_FORMAT_BE: "dd-mm-yyyy",
  DATE_FORMAT_BE_DMY: "DD-MM-YYYY",
  DATE_FORMAT_BE_YMD: "YYYY-MM-DD",
  DATE_SPLIT: ",",
  DEBOUNCE_TIME: 500,
  DECIMAL_MIN_VALUE: 0.1,
  DEFAULT_NOTIFICATION_LIMIT: 20,
  DECREMENT_ONE: 1,
  DEFAULT_CURRENCY: "$",
  DEFAULT_NUMBER_OF_LOCATIONS: 1,
  UNKNOWN_NUMBER_OF_LOCATIONS: "?",
  DEFAULT_VALUE: 0,
  DEFAULT_TIMEZONE: "America/Panama",
  DENTIST_KEY: "dentist",
  DESCRIPTION_PREVIEW_LIMIT: 450,
  DISABLE: "disable",
  DISABLED: false,
  DOCUMENT: {
    ADD: "add",
    ADD_CONFIRM: "add-confirm",
    DELETE: "delete",
    OFFICE: "office",
    PROFESSIONAL: "professional",
    PROFILE: "profile",
    TYPE: "type",
    USER: "user",
  },
  DO_NOT_SEND_DATA: {
    EMAIL: "tagged_user_email",
    ID: "tagged_user_staff_id",
    NAME: "tagged_user_name",
    TAG_BY_NAME: "tagged_by_name",
    PHONE: "tagged_user_phone",
    UUID: "tagged_by_uuid",
  },
  DNS: {
    BOTH: 3,
    OFFICE: 1,
    PROFESSIONAL: 2,
  },
  DNS_PROFESSIONAL: "76345f1c-2230-41b6-8b2a-7bd585a8d692",
  DNS_OFFICE: "2f8080c3-c94a-49bb-b62d-3305083a16d0",
  EMAIL_KEY: "email",
  EMAIL_VALID: "email_valid",
  ENABLE: "enable",
  EXPENSE: {
    EXPENSE_OBSERVER: "timesheetUpdated",
    EXPENSE_PAYLOAD: {
      VALUE: "amount",
      REMARK: "comment",
      FILE: "files[]",
    },
    EXPENSE_TYPE: "expense_type",
    EXPENSE_TYPES: {
      LODGING: "2",
      OTHER: "3",
      TRAVEL: "1",
    },
    FILE: "file",
    MAX_FILE: 10,
    MAX_VALUE: 1000000,
    MIN_VALUE: 0,
    REMARKS: "comment",
    VALUE: "amount",
  },
  FIELD_TYPES: {
    BUTTON: "button",
    CHECKBOX: "checkbox",
    DATE: "date",
    DROPDOWN: "dropdown",
    NUMBER: "number",
    RADIO: "radio",
    TEXT: "text",
  },
  FILE: {
    NAME: "file_name",
    PATH: "file_path",
    TYPE: {
      AUDIO: "audio",
      FILE: "file",
      IMAGE: "image",
      VIDEO: "video",
    },
    MAX_FILE_SIZE: 20,
  },
  FINAL_VALUES: {
    NUMBER: 100,
    INDEX: 10,
    PERCENTAGE: 100,
  },
  FIRST_FORM: 1,
  FIRST_TEN_ITEM: 10,
  FIRST_VALUE_INDEX: 1,
  FIRST_VERSION: "1",
  FORMS: {
    ACCOUNT_FORM: 6,
    ADD_OFFICE_CHECK_FORM: 6,
    ADD_OFFICE_FORM: 5,
    BILL_FORM: 5,
    CHECKING_FORM: 3,
    CHECKING_COMPLETED_FORM: 4,
    LINK_AND_MERGE_FORM: 1,
    LINK_COMPLETE_FORM: 7,
    MERGE_LAST_FORM: 8,
    OFFICE_COMPLETE_FORM: 7,
    SELECT_OFFICE_FORM: 2,
  },
  GENERIC_TIME_SHEET_REPORT: "1",
  GO_AFTER_TWO: 2,
  HTTP_STATUS: {
    BAD_REQUEST: 400,
    CONFLICT: 409,
    ERROR: "error",
    FORBIDDEN: 403,
    INTERNAL_SERVER_ERROR: 500,
    INVALID_DATA: 422,
    NOT_FOUND: 404,
    SUCCESS: 200,
    UNAUTHORIZED: 401,
  },
  INCREMENT: 1,
  INCOMPLETE_STATUS: 2,
  INITIAL_VALUE: 0,
  INITIAL_VALUES: {
    CLIENT_STATE: false,
    COUNT: 1,
    EMPTY_ARRAY: [],
    EMPTY_OBJECT: {},
    EMPTY_STATE: "",
    FALSE_STATE: false,
    INDEX: 0,
    NOT_VALUE_STATE: undefined,
    NULL_STATE: null,
    NUMBER: 0,
    PERCENTAGE: 0,
    START_STATUS_KEY: 1,
    STRING: "",
    TRUE_STATE: true,
    UNDEFINED_STATE: undefined,
  },
  IS_DELETE: 1,
  IS_OVER_DUE_EXIST: 1,
  IS_VIEW_PAGE: "view-role",
  JOB_ID: 4,
  KILO_BYTE: 1024,
  LAST_OFFICE_TAB: 4,
  LEVEL_UNIT: 1,
  LINK_FORM: "1",
  LOCAL_TYPE: {
    LOCAL_STORAGE: "JSON",
  },

  LOCAL_STORAGE: {
    ACCESS_TOKEN: "ACCESS_TOKEN",
    PROFILE: "PROFILE",
    REFRESH_TOKEN: "REFRESH_TOKEN",
  },
  MAX_FILE_SIZE_BYTES: 20 * 1024 * 1024,
  MERGE_FORM: "2",
  MIN_VALUE: 1,
  MOBILE_INDEX: {
    FIRST_NUMBER_OF_MOBILE_INDEX: 1,
    FOURTH_NUMBER_OF_MOBILE_INDEX: 4,
    SEVENTH_NUMBER_OF_MOBILE_INDEX: 7,
  },
  MOBILE: "mobile",
  MOBILE_NUMBER: "mobileNumber",
  PARENT: 1,
  AP_CONTACT_MOBILE: "apContactDirectLine",
  AP_CONTACT_EMAIL: "apContactEmail",
  MARK_AS_INVALID: "mark_as_invalid",
  MOBILE_PATTERN: "999-999-9999",
  MOBILE_WITH_CODE: 11,
  MODAL: {
    LG: "lg",
    MD: "md",
    SM: "sm",
    XL: "xl",
  },
  MSA_TYPE: {
    MSA1: 1,
  },
  NOTE_UUID: "{noteUuid}",
  NOT_AVAILABLE: "NA",
  NOT_FIND: -1,
  NOT_FOUND_VALUE: -1,
  NOT_VALUE: null,
  NOTIFICATION: {
    STATUS: {
      STATUS_APPROVE: 1,
      STATUS_NEW_JOB: 5,
      STATUS_PENDING: 2,
      STATUS_REJECT: 3,
      STATUS_RELEASE: 4,
    },
    TYPE: {
      NOTIFICATION_CONTRACT: 2,
      NOTIFICATION_JOB: 1,
      NOTIFICATION_OFFICE_PROFILE: 3,
      NOTIFICATION_PROFESSIONAL_PROFILE: 4,
      NOTIFICATION_NOTES: 8,
      TIMESHEET_NOTES_PROFESSIONAL: 9,
      TIMESHEET_DISPUTE: 6,
      INVOICE_PAYMENT: 14,
      PROSPECT: 13,
      NOTES_POSTPONE: 11,
      NOTES_COMPLETE: 12,
      RECRUITER_ASSIGNMENT: 18,
    },
  },
  OFFICE: "office",
  OFFICE_ID: 1,
  OFFICE_DATA_VALUE: "2",
  OFFICE_MOBILE: "office_mobile",
  PARENT_CATEGORY_UUID: "parentCategoryUuid",
  PAYMENT: "payment",
  PAY_ROLL_KEY: 2,
  PENDING_STATUS: 1,
  CANCELLED_STATUS: 5,
  PDF: "PDF",
  PDF_FORMAT: "application/pdf",
  PERCENTAGE: "%",
  PRIMARY_CONTACT: "primaryAccount",
  AP_CONTACT: "apAccount",
  PROSPECTS: { ID: 4, NOTES: 1 },
  POSITION: {
    RIGHT: "right",
  },
  RADIO_YES: "1",
  REFERRAL_MANAGEMENT: {
    ADD: 1,
    DISABLE: 3,
    ENABLE: 2,
    OFFICE: 1,
    PROFESSIONAL: 2,
    PROSPECT: 11,
  },
  REFERRAL_KEY: 3,
  REMOVE: "remove",
  REMOVE_USER: 6,
  SIZE: {
    XL: "xl",
  },
  STATEMENT: {
    MONTHLY_INVOICE_STATEMENT: 1,
  },
  STATUS: {
    DANGER: "danger",
    DISABLED: "disabled",
    ENABLED: "enabled",
    ERROR: "error",
    FAILED: "failed",
    IN_PROGRESS: "inProgress",
    INFO: "info",
    NONE: "",
    SUCCESS: "success",
    WARNING: "warning",
  },
  SORT: "sort",
  STRING_TYPE: "string",
  SUPER_ADMIN: 3,
  TABLE_KEY: "table",
  TAB_ID: {
    OFFICE: 6,
    PROFESSIONAL_ACTIVE_NOTE: 8,
    PROFESSIONAL_IN_ACTIVE_NOTE: 7,
    PROSPECT: 1,
  },
  THREE_DECIMAL_VALUE: 3,
  TIME: {
    START_OF_DAY: "00:00 AM",
  },
  TIMESHEET: {
    APPROVE: "approve",
    REJECT: "reject",
    TIMESHEET_UUID: "timesheetUuid",
  },
  TIMESHEET_STATUS: {
    APPROVED: 3,
    SUBMITTED: 2,
    CANCELLED: 5,
  },
  TIME_OUT_300: 300,
  TIME_SHEET_ID: "6",
  TIME_ZONE: "EST",
  TOAST_TYPE: {
    AUTOCLOSE: 1000,
    ERROR: "error",
    INFO: "info",
    SUCCESS: "success",
    TIMER: 3000,
    WARNING: "warning",
  },
  TOKEN: "token",
  TWO_DIGIT_CONVERT: 10,
  USER: {
    ACTIVE: "4",
    DE_ACTIVE: "8",
    INACTIVE: "5",
    IN_COMPLETE: 2,
    IN_REVIEW: 3,
    OFFICE: 1,
    PROFESSIONAL: 2,
    JOB_NOTE_TYPE: 3,
    PROSPECT: 3,
    PROSPECT_USER_TYPE: 11,
    OFFICE_TYPE: {
      DSO: 1,
      PRIVATE: 2,
      MULTI_PRACTICE: 3,
    },
    PROFILE: {
      ACTIVE: 7,
      RELEASE_CONTRACT: 6,
    },
    RELEASE_CONTRACT: "3",
    REMOVED: "6",
  },
  USER_TYPE: {
    OFFICE: {
      KEY: 1,
      NAME: "office",
    },
    PROFESSIONAL: {
      KEY: 2,
      NAME: "professional",
    },
    ADMIN: {
      KEY: 3,
      NAME: "admin",
    },
  },
  COUNTRY_CODE: "+1",
  LAST_TEN: -10,
  LAST_TWELVE: -12,
  UNFILLED: 7,
  ADDENDUM: "6192237f-8720-415c-973d-72bf1dbe0719",
  UNDEFINED: "undefined",
  ZIP_CODE_LENGTH: 5,
  ZIP_CODE_PREFECT_LENGTH: 9,
  URL_MAX_LENGTH: 255,
  WEBSITE: "website",
  INVOICE_SETUP: {
    MASTER_ONLY: 1,
    MASTER_WITH_CHILD: 2,
    CHILD_SPECIFIC: 3,
  },
  BILLING_TYPE_PARENT: 1,
  BILLING_TYPE_CHILD: 2,
  BILLING_TYPE_MIXED: 3,
};
